import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export default api;
